import {
  DISCLAIMERS_ADD_ASYNC,
  DISCLAIMERS_REQUEST_ASYNC,
  DISCLAIMERS_UPDATE_ASYNC,
} from './constants'

const getDisclaimers = () => ({ type: DISCLAIMERS_REQUEST_ASYNC.INITIATE })
export const getDisclaimersSuccess = (data) => ({
  type: DISCLAIMERS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getDisclaimersError = (error) => ({
  type: DISCLAIMERS_REQUEST_ASYNC.ERROR,
  error,
})
const getDisclaimersCancel = () => ({ type: DISCLAIMERS_REQUEST_ASYNC.CANCEL })

const addDisclaimers = (disclaimer) => ({
  type: DISCLAIMERS_ADD_ASYNC.INITIATE,
  payload: { disclaimer },
})
export const addDisclaimersSuccess = (ids) => ({
  type: DISCLAIMERS_ADD_ASYNC.SUCCESS,
  payload: { ...ids },
})
export const addDisclaimersError = (error) => ({
  type: DISCLAIMERS_ADD_ASYNC.ERROR,
  payload: { error },
})

const updateDisclaimers = (disclaimer) => ({
  type: DISCLAIMERS_UPDATE_ASYNC.INITIATE,
  payload: { disclaimer },
})
export const updateDisclaimersSuccess = (id) => ({
  type: DISCLAIMERS_UPDATE_ASYNC.SUCCESS,
  payload: { id },
})
export const updateDisclaimersError = (error) => ({
  type: DISCLAIMERS_UPDATE_ASYNC.ERROR,
  payload: { error },
})

export default {
  // to props
  getDisclaimers,
  getDisclaimersCancel,
  addDisclaimers,
  updateDisclaimers,
}
